<ds-filter class="ds-mt-6" [filterItems]="filterItems" (searchChange)="filterChange.emit($event)" />
